export default __webpack_public_path__ + "static/media/check-circle.f2a92351.svg";